export enum LoginMessage {
    LOGIN_SUCCESS_MESSAGE = "Login Successfully",

}
export enum SignupMessage {
    SIGNUP_SUCCESS_MESSAGE = "Sign Up Successfully",

}